import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const ConfirmDeleteModal = ({ open, onClose, onConfirm, item }) => {

  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t(StringKeys.CONFIRM_ACTION)}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {item
            ? t(StringKeys.ARE_YOU_SURE_YOU_WANT_TO_DELETE_X, {x:`${item}`})
            : t(StringKeys.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS)
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t(StringKeys.CANCEL)}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {t(StringKeys.CONFIRM)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;